import React from "react";

const Button = React.forwardRef(function Button({
    children,
    variant = "primary",
    size = "md",
    as: As = "button",
    className = "",
    ...rest
}, ref) {
    return (
        <As
            ref={ref}
            className={`tr-btn tr-btn--${variant} tr-btn--${size} tr-focusable ${className}`}
            {...rest}
        >
            {children}
        </As>
    );
});

export default Button;
